// extracted by mini-css-extract-plugin
module.exports = {"price":"BW-z","onSale":"CW-z"};